import React, { useState, useEffect } from "react";
import axios from "axios";
import { io } from "socket.io-client";
import { useNavigate } from "react-router-dom";
import "./Chat.css";
import { formatTime, formatDateLabel } from "../utils/messageUtils";
import { uploadAttachment } from "../utils/attachment";
const socket = io("https://rhrmapi.up2dateinc.com");

 
// or email — use whatever you stored during login

export default function Chat({ user }) {
  const navigate = useNavigate();
  const loggedUser = localStorage.getItem("email");

  const [userSearch, setUserSearch] = useState(""); // ✅ SEARCH STATE
  const [file, setFile] = useState(null);
  const [users, setUsers] = useState([]);
  const [receiver, setReceiver] = useState("");
  const [message, setMessage] = useState("");
  const [chat, setChat] = useState([]);

  const [showMenu, setShowMenu] = useState(false);
  const [showOptions, setShowOptions] = useState(false);
  const [activeUserMenu, setActiveUserMenu] = useState(null);

  const [currentUser, setCurrentUser] = useState(null);
  const [searchQuery, setSearchQuery] = useState("");
  const [muted, setMuted] = useState(false);

  const [deleteMode, setDeleteMode] = useState(false);
  const [selectedMessages, setSelectedMessages] = useState([]);

  const [previewImage, setPreviewImage] = useState(null);

  const [hoveredMsgId, setHoveredMsgId] = useState(null);

  const [showGroupInfo, setShowGroupInfo] = useState(false);
  // ✅ GROUP STATES (ADD ONLY)
  const [groups, setGroups] = useState([]);
  const [showGroupModal, setShowGroupModal] = useState(false);
  const [groupName, setGroupName] = useState("");
  const [selectedUsers, setSelectedUsers] = useState([]);
  const [isGroupChat, setIsGroupChat] = useState(false);
  const [editingMsgId, setEditingMsgId] = useState(null);
  const [editText, setEditText] = useState("");


  useEffect(() => {
    const saved = localStorage.getItem("receiver");
    if (saved) setReceiver(saved);
  }, []);

  useEffect(() => {
  const fetchUsers = async () => {
    try {
      const token = localStorage.getItem("token");

      const res = await axios.get(
        `https://rhrmapi.up2dateinc.com/api/auth/approved/${loggedUser}`
      );

      const removed = JSON.parse(localStorage.getItem("removedUsers")) || [];
      const pinned = JSON.parse(localStorage.getItem("pinnedChats")) || [];

      let filtered = res.data
        .filter(u => u.email !== loggedUser)
        .filter(u => !removed.includes(u.email));

      filtered.sort((a, b) => {
        if (pinned.includes(a.email)) return -1;
        if (pinned.includes(b.email)) return 1;
        return 0;
      });

      setUsers(filtered);

    } catch (err) {
      console.log("User Load Error:", err.message);
    }
  };

  fetchUsers();
}, []);   // ⭐ IMPORTANT

  useEffect(() => {
  

  axios
    .get("https://rhrmapi.up2dateinc.com/api/chat/messages")
    .then(res => setChat(res.data || []));

  if (loggedUser) {
  axios.get(`https://rhrmapi.up2dateinc.com/api/auth/profile/${loggedUser}`)
    .then(res => setCurrentUser(res.data))
    .catch(err => console.log(err));
}

  // ✅ GROUPS
  axios.get("https://rhrmapi.up2dateinc.com/api/chat/group-messages")
  .then(res => {
    const groupMsgs = res.data.messages || [];
    const groupList = res.data.groups || [];

    setChat(prev => [...prev, ...groupMsgs]);

    // ✅ THIS IS WHAT YOU MISSED
    const myGroups = groupList.filter(g =>
      g.members?.includes(loggedUser)
    );

    setGroups(myGroups);

    groupList.forEach(g => {
      if (g.members?.includes(loggedUser)) {
        socket.emit("join_group", g.name);
      }
    });
  })
  .catch(err => console.error(err));


  socket.emit("register", loggedUser);

 

  socket.on("receive_message", data => {
  const mutedList = JSON.parse(localStorage.getItem("mutedChats")) || [];

  // ❗ GROUP MESSAGE
  if (data.isGroup) {
    if (!data.members?.includes(loggedUser)) return;
  }

  // ❗ PRIVATE MESSAGE
  else {
    if (
      data.sender !== loggedUser &&
      data.receiver !== loggedUser
    ) return;
  }

  if (!mutedList.includes(data.sender)) {
    setChat(prev => {
      const exists = prev.find(
        m => m.id === data.id || m.tempId === data.tempId
      );
      if (exists) return prev;   // ✅ prevent duplicate
      return [...prev, data];
    });
  }
});

  socket.on("message_saved", (msg) => {
  setChat((prev) =>
    prev.map((m) =>
      m.tempId === msg.tempId
        ? { ...m, ...msg } // ✅ replace uploading → real image
        : m
    )
  );
});

  return () => {
  socket.off("receive_message");
  socket.off("message_saved"); // ✅ add this
};
}, [loggedUser]);

  useEffect(() => {
    if (receiver) {
      const mutedList = JSON.parse(localStorage.getItem("mutedChats")) || [];
      setMuted(mutedList.includes(receiver));
    }
  }, [receiver]);

  const selectUser = (u) => {
    setReceiver(u.email);
    setIsGroupChat(false);   // ✅ ADD THIS
    localStorage.setItem("receiver", u.email);
    localStorage.removeItem(`unread_${u.email}`);
    setSearchQuery("");
  };

 const sendMessage = async () => {
  if (!receiver) return;

  let fileUrl = null;

  if (file) {
    fileUrl = await uploadAttachment(file);
  }

  if (!message.trim() && !fileUrl) return;

  let groupMembers = [];

if (isGroupChat) {
  const group = groups.find(g => g.name === receiver);
  groupMembers = group?.members || [];
}

 const tempId = Date.now();   // ✅ VERY IMPORTANT

 const data = {
  id: tempId,          // temporary
  tempId: tempId,      // ✅ ADD THIS
  sender: loggedUser,
  senderName: fullName,
  receiver,
  message,
  file: fileUrl,
  time: new Date(),
  isGroup: isGroupChat,
  members: groupMembers,
  groupName: isGroupChat ? receiver : null  // ✅ ADD THIS
};

  // ✅ ADD THIS LINE (instant UI update)
  setChat(prev => [...prev, data]);

  socket.emit("send_message", data);

  setMessage("");
  setFile(null);
};

const handleFileChange = (e) => {
  setFile(e.target.files[0]);
};
  const logout = () => {
    localStorage.clear();
    navigate("/");
  };

  const goProfile = () => navigate("/profile");

  const clearChat = () => {
    localStorage.setItem(`cleared_${user}_${receiver}`, Date.now());
    setShowOptions(false);
  };

  const muteChat = () => {
    let mutedList = JSON.parse(localStorage.getItem("mutedChats")) || [];

    if (mutedList.includes(receiver)) {
      mutedList = mutedList.filter(u => u !== receiver);
    } else {
      mutedList.push(receiver);
    }

    localStorage.setItem("mutedChats", JSON.stringify(mutedList));
    setMuted(mutedList.includes(receiver));
    setShowOptions(false);
  };

  const searchChat = () => {
    const text = prompt("Enter search text");
    setSearchQuery(text || "");
    setShowOptions(false);
  };

  const handleSelectMessage = (id) => {
    setSelectedMessages(prev =>
      prev.includes(id)
        ? prev.filter(i => i !== id)
        : [...prev, id]
    );
  };

  const deleteSelectedMessages = async () => {
  try {
    for (let id of selectedMessages) {

      const url = isGroupChat
        ? "https://rhrmapi.up2dateinc.com/api/chat/group-message/delete"
        : "https://rhrmapi.up2dateinc.com/api/chat/message/delete";

      await axios.delete(url, {
        data: { id }
      });
    }

    // ✅ REMOVE FROM UI
    setChat(prev =>
      prev.filter(msg => !selectedMessages.includes(msg.id))
    );

    setSelectedMessages([]);
    setDeleteMode(false);

  } catch (err) {
    console.error("Delete failed:", err);
  }
};

  const removeChat = (email) => {
    localStorage.setItem(`cleared_${user}_${email}`, Date.now());

    let removed = JSON.parse(localStorage.getItem("removedUsers")) || [];
    if (!removed.includes(email)) removed.push(email);

    localStorage.setItem("removedUsers", JSON.stringify(removed));

    setUsers(prev => prev.filter(u => u.email !== email));

    if (receiver === email) setReceiver("");

    setActiveUserMenu(null);
  };

  const togglePin = (email) => {
    let pinned = JSON.parse(localStorage.getItem("pinnedChats")) || [];

    if (pinned.includes(email)) {
      pinned = pinned.filter(e => e !== email);
    } else {
      pinned.unshift(email);
    }

    localStorage.setItem("pinnedChats", JSON.stringify(pinned));

    setUsers(prev => {
      const pinnedUsers = prev.filter(u => pinned.includes(u.email));
      const others = prev.filter(u => !pinned.includes(u.email));
      return [...pinnedUsers, ...others];
    });

    setActiveUserMenu(null);
  };

  const muteUser = (email) => {
    let muted = JSON.parse(localStorage.getItem("mutedChats")) || [];

    if (muted.includes(email)) {
      muted = muted.filter(u => u !== email);
    } else {
      muted.push(email);
    }

    localStorage.setItem("mutedChats", JSON.stringify(muted));
    setActiveUserMenu(null);
  };

  const toggleUnread = (email) => {
    const key = `unread_${email}`;

    if (localStorage.getItem(key)) {
      localStorage.removeItem(key);
    } else {
      localStorage.setItem(key, "true");
    }

    setActiveUserMenu(null);
  };

  const clearedTime = localStorage.getItem(`cleared_${user}_${receiver}`);

  const baseChat = chat.filter(c => {
    // 👥 GROUP CHAT
    if (isGroupChat) {
      return c.groupName === receiver;
    }
    const match =
      (c.sender === loggedUser && c.receiver === receiver) ||
      (c.sender === receiver && c.receiver === loggedUser);

    if (!match) return false;

    if (clearedTime && new Date(c.time) < new Date(parseInt(clearedTime))) {
      return false;
    }

    return true;
  });

  const filteredChat = searchQuery
    ? baseChat.filter(c =>
        c.message.toLowerCase().includes(searchQuery.toLowerCase())
      )
    : baseChat;

  const receiverName =
    users.find(u => u.email === receiver)?.name || receiver;

  const fullName =
    currentUser?.firstName
      ? `${currentUser.firstName} ${currentUser.lastName || ""}`.trim()
      : user;

  const initial = currentUser?.firstName
    ? currentUser.firstName.charAt(0).toUpperCase()
    : user?.charAt(0).toUpperCase();

  // ✅ SELECT USERS
const toggleUserSelection = (email) => {
  setSelectedUsers(prev =>
    prev.includes(email)
      ? prev.filter(u => u !== email)
      : [...prev, email]
  );
};
const createGroup = async () => {
  if (!groupName.trim() || selectedUsers.length === 0) {
    alert("Enter group name and select users");
    return;
  }

  const newGroup = {
    name: groupName,
    members: [loggedUser, ...selectedUsers]
  };

  await axios.post("https://rhrmapi.up2dateinc.com/api/chat/group", newGroup);

  setGroups(prev => [...prev, newGroup]);

  setGroupName("");
  setSelectedUsers([]);
  setShowGroupModal(false);
};
  
const removeGroup = (groupName) => {
  setGroups(prev => prev.filter(g => g.name !== groupName));

  if (receiver === groupName) {
    setReceiver("");
  }

  setActiveUserMenu(null);
};

const exitGroup = (groupName) => {
  setGroups(prev =>
    prev.map(g =>
      g.name === groupName
        ? {
            ...g,
            members: g.members.filter(m => m !== user)
          }
        : g
    )
  );

  if (receiver === groupName) {
    setReceiver("");
  }

  setShowGroupInfo(false);
};
const getUserName = (email) => {
  const u = users.find(x => x.email === email);
  return u ? u.name : email;
};


  return (
  <div className="teams-container">

    {/* SIDEBAR */}
    <div className="sidebar">
      <div className="top-section">
        <h3>Chats</h3>

        {/* SEARCH BAR */}
        <input
          type="text"
          placeholder="Search users..."
          value={userSearch}
          onChange={(e) => setUserSearch(e.target.value)}
          style={{
            width: "90%",
            padding: "6px",
            margin: "8px",
            borderRadius: "6px",
            border: "1px solid #ccc",
            position: "relative",
            zIndex: 9999,          // ✅ ADD THIS
            pointerEvents: "auto"  // ✅ ADD THIS
          }}
        />

{/* ✅ GROUP LIST (UPDATED) */}
{groups.map((g, i) => {
  const pinned = JSON.parse(localStorage.getItem("pinnedChats")) || [];
  const mutedList = JSON.parse(localStorage.getItem("mutedChats")) || [];
  const isUnread = localStorage.getItem(`unread_${g.name}`);

  return (
    <div key={`group-${i}`} className="user-row">

      {/* GROUP ITEM */}
      <div
        className={`user-item ${receiver === g.name ? "active" : ""}`}
      onClick={() => {
  setReceiver(g.name);
  setIsGroupChat(true);
  socket.emit("join_group", g.name);
  
}}
      >
        👥 {g.name}
        {pinned.includes(g.name) && " 📌"}
        {mutedList.includes(g.name) && " 🔕"}
        {isUnread && " 🔴"}
      </div>

      {/* THREE DOT MENU */}
      <span
        className="user-menu-icon"
        onClick={() =>
          setActiveUserMenu(activeUserMenu === g.name ? null : g.name)
        }
      >
        ⋯
      </span>

      {/* DROPDOWN */}
      {activeUserMenu === g.name && (
        <div className="user-menu-dropdown">

          <p onClick={() => toggleUnread(g.name)}>
            {isUnread ? "✅ Mark as read" : "📩 Mark as unread"}
          </p>

          <p onClick={() => removeGroup(g.name)}>🗑 Remove</p>

          <p onClick={() => togglePin(g.name)}>
            {pinned.includes(g.name) ? "❌ Unpin" : "📌 Pin"}
          </p>

          <p onClick={() => muteUser(g.name)}>
            {mutedList.includes(g.name)
              ? "🔔 Unmute"
              : "🔕 Mute"}
          </p>

        </div>
      )}
    </div>
  );
})}

        {users
          .filter(u => {
            const name = (u.name || "").toLowerCase();
            const email = (u.email || "").toLowerCase();
            const search = userSearch.toLowerCase();

            return (
              name.includes(search) ||
              email.includes(search)
            );
          })
          .map((u, i) => {
            const pinned = JSON.parse(localStorage.getItem("pinnedChats")) || [];
            const mutedList = JSON.parse(localStorage.getItem("mutedChats")) || [];
            const isUnread = localStorage.getItem(`unread_${u.email}`);

            return (
              <div key={i} className="user-row">

                <div
                  className={`user-item ${receiver === u.email ? "active" : ""}`}
                  onClick={() => selectUser(u)}
                >
                  {u.name || u.email}
                  {pinned.includes(u.email) && " 📌"}
                  {mutedList.includes(u.email) && " 🔕"}
                  {isUnread && " 🔴"}
                </div>

                <span
                  className="user-menu-icon"
                  onClick={() =>
                    setActiveUserMenu(activeUserMenu === u.email ? null : u.email)
                  }
                >
                  ⋯
                </span>

                {activeUserMenu === u.email && (
                  <div className="user-menu-dropdown">
                    <p onClick={() => toggleUnread(u.email)}>
                      {localStorage.getItem(`unread_${u.email}`)
                        ? "✅ Mark as read"
                        : "📩 Mark as unread"}
                    </p>

                    

                    <p onClick={() => togglePin(u.email)}>
                      {pinned.includes(u.email) ? "❌ Unpin" : "📌 Pin"}
                    </p>

                    <p onClick={() => muteUser(u.email)}>
                      {mutedList.includes(u.email)
                        ? "🔔 Unmute"
                        : "🔕 Mute"}
                    </p>
                  </div>
                )}
              </div>
            );
          })}
      </div>

      {/* BOTTOM SECTION (RESTORED) */}
      <div className="bottom-section">
        <div className="current-user">
          <div className="avatar">{initial}</div>
          <div className="user-name">{fullName}</div>
        </div>

        <hr />

        <div className="settings-container">
          <div style={{ cursor: "pointer" }} onClick={() => setShowMenu(!showMenu)}>
            ⚙️ Settings
          </div>

          {showMenu && (
            <div className="settings-dropdown">
              <p onClick={() => { setShowMenu(false);navigate("/profile"); }}>Profile</p>
              <p onClick={() => setShowGroupModal(true)}> New Group</p>


            </div>
          )}
        </div>
      </div>
    </div>
{previewImage && (
  <div className="image-preview-overlay" onClick={() => setPreviewImage(null)}>
    
    <img
      src={previewImage}
      alt="preview"
      className="image-preview"
      onClick={(e) => e.stopPropagation()} // prevent close when clicking image
    />

    <span
      className="close-preview"
      onClick={() => setPreviewImage(null)}
    >
      ×
    </span>
  </div>
)}
    {/* CHAT SECTION (FULLY RESTORED) */}
    {receiver && (
      <div className="chat-section">

        <div className="chat-header">
         <h3
onClick={() => {
  if (isGroupChat) {
    navigate(`/group/${receiver}`);
  }
}}
  style={{ cursor: isGroupChat ? "pointer" : "default" }}
>
  {receiverName} {muted && "🔕"}
</h3>

          <div className="chat-menu">
            <span onClick={() => setShowOptions(!showOptions)}>⋮</span>

            {showOptions && (
              <div className="chat-options">
                <p onClick={() => {
                  setDeleteMode(true);
                  setShowOptions(false);
                }}>🗑 Delete Messages</p>
                <p onClick={searchChat}>🔍 Search</p>
                <p onClick={clearChat}>🗑 Clear Chat</p>
                <p onClick={muteChat}>
                  {muted ? "🔔 Unmute" : "🔕 Mute"}
                </p>
              </div>
            )}
          </div>
        </div>


        {deleteMode && (
          <div className="delete-bar">
            <span>{selectedMessages.length} selected</span>

            <div>
              <button onClick={deleteSelectedMessages}>Delete</button>
              <button onClick={() => {
                setDeleteMode(false);
                setSelectedMessages([]);
              }}>Cancel</button>
            </div>
          </div>
        )}



        <div className="chat-body">
          {filteredChat.map((c, i) => {
            const prevDate = i > 0 ? formatDateLabel(filteredChat[i - 1].time) : null;
            const currDate = formatDateLabel(c.time);

            return (
              <React.Fragment key={i}>
                {currDate !== prevDate && (
                  <div className="date-separator">{currDate}</div>
                )}

                <div 
                className={`msg 
                  ${c.sender === loggedUser ? "right" : "left"} 
                   ${selectedMessages.includes(c.id) ? "selected" : ""}
                `}
                onMouseEnter={() => setHoveredMsgId(c.id)}
                onMouseLeave={() => setHoveredMsgId(null)}
 
                >

  {c.sender === loggedUser && hoveredMsgId === c.id && editingMsgId !== c.id && (
  <span
    style={{
      position: "absolute",
      top: "5px",
      right: "10px",
      cursor: "pointer",
      fontSize: "14px"
    }}
    onClick={() => {
      setEditingMsgId(c.id);
      setEditText(c.message);
    }}
  >
    ✏️
  </span>
)}


                  {deleteMode && (
                    <input
                      type="checkbox"
                      checked={selectedMessages.includes(c.id)}
                      onChange={() => handleSelectMessage(c.id)}
                    />
                  )}
                  

{isGroupChat && (
  <div
    style={{
      fontSize: "12px",
      fontWeight: "bold",
      marginBottom: "2px",
      color: c.sender === loggedUser ? "#2ecc71" : "#555"
    }}
  >
    {c.sender === loggedUser ? "You" : (c.senderName || c.sender)}
  </div>
)}
{editingMsgId === c.id ? (
  <div style={{ display: "flex", alignItems: "center", gap: "6px" }}>
    <input
      value={editText}
      onChange={(e) => setEditText(e.target.value)}
      style={{ padding: "4px", flex: 1 }}
    />

    {/* ✔ SAVE */}
    <span
  style={{ cursor: "pointer", color: "green", fontSize: "16px" }}
  onClick={async () => {
    try {
      const url = c.groupName
        ? "https://rhrmapi.up2dateinc.com/api/chat/group-message/edit"
        : "https://rhrmapi.up2dateinc.com/api/chat/message/edit";

      await axios.put(url, {
        id: c.id,
        message: editText
      });

      setChat(prev =>
        prev.map(msg =>
          msg.id === c.id
            ? { ...msg, message: editText, edited: true }
            : msg
        )
      );

      setEditingMsgId(null);
    } catch (err) {
      console.error("Edit failed:", err);
    }
  }}
>
  ✔
</span>

    {/* ❌ CANCEL */}
    <span
      style={{ cursor: "pointer", color: "red", fontSize: "16px" }}
      onClick={() => setEditingMsgId(null)}
    >
      ❌
    </span>
  </div>
) : (
  <span>
    {c.message} 
  </span>
)}{c.file && (
  <div className="attachment-box">



    {/* 🖼 IMAGE */}
    {c.file.match(/\.(jpeg|jpg|png|gif|webp)$/i) && (
      <img
        src={c.file}
        alt="attachment"
        className="attachment-image"
        onClick={() => setPreviewImage(c.file)}
      />
    )}

    {/* 📄 PDF */}
    {c.file.match(/\.pdf$/i) && (
      <div
        className="attachment-file pdf"
        onClick={() => window.open(c.file, "_blank")}
      >
        <div className="file-icon">📄</div>
        <div className="file-info">
          <div className="file-name">
            {c.file.split("/").pop()}
          </div>
          <div className="file-type">PDF</div>
        </div>
        <div className="download">⬇</div>
      </div>
    )}

    {/* 📊 EXCEL */}
    {c.file.match(/\.(xls|xlsx)$/i) && (
      <div
        className="attachment-file excel"
        onClick={() => window.open(c.file, "_blank")}
      >
        <div className="file-icon">📊</div>
        <div className="file-info">
          <div className="file-name">
            {c.file.split("/").pop()}
          </div>
          <div className="file-type">Excel</div>
        </div>
        <div className="download">⬇</div>
      </div>
    )}

    {/* 📎 OTHER FILES */}
    {!c.file.match(/\.(jpeg|jpg|png|gif|webp|pdf|xls|xlsx)$/i) && (
      <div
        className="attachment-file other"
        onClick={() => window.open(c.file, "_blank")}
      >
        <div className="file-icon">📎</div>
        <div className="file-info">
          <div className="file-name">
            {c.file.split("/").pop()}
          </div>
          <div className="file-type">File</div>
        </div>
        <div className="download">⬇</div>
      </div>
    )}

  </div>
)}
<div className="meta">
  {c.edited && (
    <span style={{ fontSize: "11px", marginRight: "6px", opacity: 0.7 }}>
      edited
    </span>
  )}

  <span>{formatTime(c.time)}</span>

  {c.sender ===  loggedUser && <span>✓✓</span>}
</div>
                </div>
              </React.Fragment>
            );
          })}
        </div>

<div className="chat-footer">
  <input
    type="file"
    id="fileInput"
    style={{ display: "none" }}
    onChange={handleFileChange}
  />

  <button onClick={() => document.getElementById("fileInput").click()}>
    📎
  </button>
<input
  value={message}
  placeholder="Type message..."
  onChange={(e) => setMessage(e.target.value)}
  onKeyDown={(e) => {
    if (e.key === "Enter") {
      e.preventDefault(); // prevents newline / default behavior
      sendMessage();
    }
  }}
/>

  <button onClick={sendMessage}>Send</button>
   {file && (
    <div style={{ fontSize: "12px", marginTop: "5px" }}>
      📎 {file.name}
    </div>
  )}

{showGroupModal && (
  <div className="group-modal">
    <div className="group-box">
      <h3>Create Group</h3>

      {/* GROUP NAME */}
      <input
        type="text"
        placeholder="Enter group name"
        value={groupName}
        onChange={(e) => setGroupName(e.target.value)}
      />

      {/* USER LIST */}
      <div className="group-users">
        {users.map((u, i) => (
          <div key={i}>
            <label>
              <input
                type="checkbox"
                checked={selectedUsers.includes(u.email)}
                onChange={() => toggleUserSelection(u.email)}
              />
              {u.name || u.email}
            </label>
          </div>
        ))}
      </div>

      {/* BUTTONS */}
      <div className="group-actions">
        <button onClick={createGroup}>Create</button>
        <button onClick={() => setShowGroupModal(false)}>Cancel</button>
      </div>
    </div>
  </div>
)}
</div>

      </div>
    )}
  </div>
);
}
